"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "app-container"
  }, [_c("el-tabs", {
    attrs: {
      type: "card"
    },
    model: {
      value: _vm.activeName,
      callback: function callback($$v) {
        _vm.activeName = $$v;
      },
      expression: "activeName"
    }
  }, [_c("el-tab-pane", {
    attrs: {
      label: _vm.$t("table.allAnchors"),
      name: "allAnchor"
    }
  }, [_c("all-anchor")], 1), _vm._v(" "), _c("el-tab-pane", {
    attrs: {
      label: _vm.$t("table.recommended"),
      name: "recommend"
    }
  }, [_c("recommend")], 1), _vm._v(" "), _c("el-tab-pane", {
    attrs: {
      label: _vm.$t("table.notRecommend"),
      name: "notRecommend"
    }
  }, [_c("not-recommend")], 1)], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;